import { Injectable } from '@angular/core';
import {Endpoints} from "../../customs/endpoints";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {CommonResponse} from "../../customs/_models/Response";
import { TypeAnalyseDTO } from '../../customs/_models/typeAnalyseDTO';
import { ShortTypeAnalyseDto } from '../../customs/_models/type.analyse.dtos';

@Injectable({
  providedIn: 'root'
})
export class TypeAnalyseService {

    constructor(
        private endpoints: Endpoints,
        private http : HttpClient) { }

    public fetchTypeAnalyseList(matId: number): Observable<CommonResponse>{
        console.log(`${this.endpoints.type_analyse_base_endpoint}/ShortDtoList/${matId}`)
        return this.http.get<CommonResponse>(`${this.endpoints.type_analyse_base_endpoint}/ShortDtoList/${matId}`);
    }

public getAllTypeAnalyses(): Observable<TypeAnalyseDTO[]> {
    return this.http.get<TypeAnalyseDTO[]>(`${this.endpoints.type_analyse_base_endpoint}`);
}
public getAllTypeAnalyse(): Observable<ShortTypeAnalyseDto[]> {
  return this.http.get<ShortTypeAnalyseDto[]>(
    `${this.endpoints.type_analyse_base_endpoint}`
  );
}

public getMethodesList(): Observable<any[]> {
    return this.http.get<any[]>(`${this.endpoints.methode_base_endpoint}`);
}


    public getTypeAnalyseById(id: number): Observable<CommonResponse> {
        return this.http.get<CommonResponse>(`${this.endpoints.type_analyse_base_endpoint}/${id}`);
    }

    public createTypeAnalyse(typeAnalyse: TypeAnalyseDTO): Observable<CommonResponse> {
        return this.http.post<CommonResponse>(`${this.endpoints.type_analyse_base_endpoint}`, typeAnalyse);
    }

    public updateTypeAnalyse(id: number, typeAnalyse: TypeAnalyseDTO): Observable<CommonResponse> {
        return this.http.put<CommonResponse>(`${this.endpoints.type_analyse_base_endpoint}/${id}`, typeAnalyse);
    }

    public deleteTypeAnalyse(id: number): Observable<CommonResponse> {
        return this.http.delete<CommonResponse>(`${this.endpoints.type_analyse_base_endpoint}/${id}`);
    }
}
